import { inject } from '@angular/core';
import { CanDeactivateFn } from '@angular/router';
import { DiscardChangesService } from '../services/discard-changes.service';

export interface CanComponentDeactivate {
  isUnsavedChanges: () => boolean;
}

export const canDeactivateGuard: CanDeactivateFn<CanComponentDeactivate> = async (component) => {
  const unsavedChangesService = inject(DiscardChangesService);

  if ((component && component.isUnsavedChanges()) || unsavedChangesService.getUnsavedChangesState()) {
    return unsavedChangesService.canDeactivate();
  }

  unsavedChangesService.setUnsavedChangesState(false);
  
  return true;

};
